import Skeleton from "react-loading-skeleton";

export default function BlankCard() {
	return (
		<>
			<li className="col-span-1 divide-y divide-gray-200 rounded-lg border-2 bg-white shadow">
				<div className="flex w-full items-center justify-between space-x-6 p-6 pb-4">
					<div className="flex-1">
						<div className="flex items-center space-x-3">
							<h3 className="text-sm font-medium text-gray-900">
								<Skeleton width={200} />
							</h3>
						</div>
						<p className="mt-1 mr-4 h-10 overflow-auto text-sm text-gray-500">
							<Skeleton style={{ width: "100%!important" }} count={2} />
						</p>
					</div>
					<Skeleton width={40} height={40} circle={true} />
				</div>

				<div className="-mt-px">
					<div className="-mt-px flex">
						<div className="-mt-px" style={{ width: "100%" }}>
							<Skeleton height={55} />
						</div>
					</div>
				</div>
			</li>
		</>
	);
}
